// yyyy-MM-dd in local time, matching the format rms-date reads/writes (date-field.component.ts).
export function todayDateString(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

// Extracts yyyy-MM-dd from an existing API date value (ISO string or Date), reading it back
// in UTC so it matches what date-field.component.ts displays (see its writeValue fix).
// Falls back to today when the value is missing/unparseable.
export function toDateOnlyString(value: unknown): string {
  if (!value) return todayDateString();
  const parsed = new Date(value as any);
  return isNaN(parsed.getTime()) ? todayDateString() : parsed.toISOString().slice(0, 10);
}
